/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Previous College View Model
    // Holds the previous College details
    /**************************************/
    function PreviousCollegeViewModel() {

        /***  PROPERTIES ***/
        this.DataList = ko.observableArray();
        /***  PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.Statuses = ko.observableArray();
        this.Credentials = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        this.IsAPASApplicant = ko.observable(false);

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("CollegeContainer");
        this.Touched = ko.observable(false);
        this.IsRequired = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        this.sectionVisibleByConfig = ko.observable(null);
        /*** SECTION PROPERTIES ***/

        /** ADD/EDIT LIST METHODS **/
        this.WorkingItem = ko.observable(new sm.portal.vm.CollegeDataItem());
        this.OriginalItem = ko.observable(new sm.portal.vm.CollegeDataItem());

        this.SaveWorkingChanges = function () {

            var workingItem = self.WorkingItem().Clone();
            workingItem.SectionRequired(self.IsRequired());
            workingItem.Status(self.GetStatusNameById(workingItem.StatusID()));
            workingItem.Credential(self.GetCredentialNameById(workingItem.CredentialID()));
            self.WorkingItem(new sm.portal.vm.CollegeDataItem());

            if (workingItem.IsVMValid()) {

                if (!workingItem.InEditMode()) {
                    // This is an Add...
                    self.DataList.push(workingItem);
                } else {
                    // NOTE: Edits automatically bind back to the list (knockout is cool, huh?)
                    workingItem.InEditMode(false);
                    self.OriginalItem().CollegeID(workingItem.CollegeID());
                    self.OriginalItem().CollegeName(workingItem.CollegeName());
                    self.OriginalItem().GradePoint(workingItem.GradePoint());
                    self.OriginalItem().GradePointOf(workingItem.GradePointOf());
                    self.OriginalItem().StartDate(workingItem.StartDate());
                    self.OriginalItem().EndDate(workingItem.EndDate());
                    self.OriginalItem().Comments(workingItem.Comments());
                    self.OriginalItem().StatusID(workingItem.StatusID());
                    self.OriginalItem().Status(workingItem.Status());
                    self.OriginalItem().PersonAcademicGoalID(workingItem.PersonAcademicGoalID());
                    self.OriginalItem().EducationalGoal(workingItem.EducationalGoal());
                    self.OriginalItem().OtherEducationalGoal(workingItem.OtherEducationalGoal());
                    self.OriginalItem().InEditMode(workingItem.InEditMode());
                    self.OriginalItem().ID(workingItem.ID());
                    self.OriginalItem().GID(workingItem.GID());
                    // New fields added only for APAS
                    self.OriginalItem().StudentID(workingItem.StudentID());
                    self.OriginalItem().ProgramName(workingItem.ProgramName());
                    self.OriginalItem().ConferralDate(workingItem.ConferralDate());
                    self.OriginalItem().Credential(workingItem.Credential());
                    self.OriginalItem().CredentialID(workingItem.CredentialID());
                    self.OriginalItem().City(workingItem.City());
                    self.OriginalItem().IsProgramConferralRequired(workingItem.IsProgramConferralRequired());
                }
                sm.portal.ui.comboBox();

                // hide the data entry view
                jQuery('.dataEntryView').hide();

                // show the display view with one item
                jQuery('.dataDisplayView').show();
                jQuery('.dataDisplayView ul.detailedList li').not('.noneAdded').show();
            }
        };

        this.GetStatusNameById = function (id) {
            if(id) {
                for (var i = 0; i < self.Statuses().length; i++) {
                    if (parseInt(self.Statuses()[i].Value()) === parseInt(id)) {
                        return self.Statuses()[i].Text();
                    }
                }
            }
            return "";
        }

        this.GetCredentialNameById = function (id) {
            if(id) {
                for (var i = 0; i < self.Credentials().length; i++) {
                    if (parseInt(self.Credentials()[i].Value()) === parseInt(id)) {
                        return self.Credentials()[i].Text();
                    }
                }
            }
            return "";
        }

        this.GetFormattedDate = function(date) {
            if (date) {
                var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
                return moment(new Date(date)).format(dateFormat);
            }
            return '';
        }

        this.CancelWorkingChanges = function () {
            self.WorkingItem(new sm.portal.vm.CollegeDataItem());

            //hide the display view
            jQuery('.dataEntryView').hide();

            // show the entry view
            jQuery('.dataDisplayView').show();
        };
        this.EditItem = function (data, event) {
            self.OriginalItem(data);
            (self.OriginalItem() && self.OriginalItem().CredentialID() && sm.portal.utility.isAPASFeatureEnabled()) ? self.OriginalItem().IsProgramConferralRequired(true) : self.OriginalItem().IsProgramConferralRequired(false);
            self.WorkingItem(data.Clone());
            self.WorkingItem().SectionRequired(self.IsRequired());
            self.WorkingItem().InEditMode(true);

            jQuery('.dataDisplayView').hide();
            jQuery('.dataEntryView').show();

            sm.portal.ui.comboBox();
        };
        this.AddItem = function (data, event) {
            self.WorkingItem(new sm.portal.vm.CollegeDataItem());
        };
        this.RemoveItem = function (data, event) {
            self.DataList.remove(function (item) { return item.CollegeID == data.CollegeID });
        };
        /** ADD/EDIT LIST METHODS **/

        /***  COMPUTED PROPERTIES ***/
        this.AnythingPopulated = ko.computed(function () {

            if (this.DataList().length > 0) {
                for (var i = 0; i < this.DataList().length; i++) {
                    var dataItem = this.DataList()[i];
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.CollegeID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.CollegeName())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.GradePoint())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.GradePointOf())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.StartDate())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.EndDate())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.Comments())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.StatusID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.Status())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.PersonAcademicGoalID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.EducationalGoal())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.OtherEducationalGoal())) return true;
                    // New fields added only for APAS
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.StudentID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.ProgramName())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.ConferralDate())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.Credential())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.CredentialID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.City())) return true;
                }
            }
            return false;
        }, this);
        this.Completed = ko.computed(function () {
            if (this.IsRequired()) {
                return this.AnythingPopulated() && this.Touched();
            } else {
                return this.Touched();
            }
        }, this);

        /***  COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("College", container.Payload.Config, true);
                // To handle inclusion usecase
                var showSection = container.Payload.Config.ShowSection;
                !sm.portal.utility.isNullOrEmpty(showSection) && this.sectionVisibleByConfig(showSection);
                self.IsAPASApplicant(container.Payload.IsAPASApplicant ? container.Payload.IsAPASApplicant : false);
            }

            if (container.Payload.ListData != undefined && container.Payload.ListData.CollegeStatuses != null && container.Payload.ListData.CollegeStatuses != undefined) {
                this.Statuses = smapi.access.loadListItemModels(container.Payload.ListData.CollegeStatuses, this.Statuses);
            }
            if (container.Payload.ListData && container.Payload.ListData.CollegeCredentials && container.Payload.ListData.CollegeCredentials) {
                this.Credentials = smapi.access.loadListItemModels(container.Payload.ListData.CollegeCredentials, this.Credentials);
            }

            if (container.Payload.Colleges != null && container.Payload.Colleges.length > 0) {
                while (this.DataList().length) this.DataList.pop();
                for (var i = 0; i < container.Payload.Colleges.length; i++) {

                    var coll = container.Payload.Colleges[i];
                    var newDataItem = new sm.portal.vm.CollegeDataItem({
                        CollegeID: coll.CollegeID,
                        CollegeName: coll.CollegeName,
                        GradePoint: coll.GradePoint,
                        GradePointOf: coll.GradePointOf,
                        Comments: coll.Comments,
                        StartDate: this.GetFormattedDate(coll.StartDate),
                        EndDate: this.GetFormattedDate(coll.EndDate),
                        StatusID: coll.StatusID,
                        Status: this.GetStatusNameById(coll.StatusID),
                        PersonAcademicGoalID: coll.PersonAcademicGoalID,
                        EducationalGoal: coll.EducationalGoal,
                        OtherEducationalGoal: coll.OtherEducationalGoal,
                        ID: coll.ID,
                        GID: coll.GID,
                        StudentID: coll.StudentID,
                        ProgramName: coll.ProgramName,
                        ConferralDate: this.GetFormattedDate(coll.ConferralDate),
                        CredentialID: coll.CredentialID,
                        City: coll.City,
                        Credential: this.GetCredentialNameById(coll.CredentialID)
                    });

                    this.DataList.push(newDataItem);
                }
            }

            this.DataLoading(false);
            this.DataLoaded(true);
            this.Touched(this.Touched() || this.DataList().length > 0);
            if (smapi.constant.applicationDebugFlag) { console.log('[CollegeVM] Data Loaded'); }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=college&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.CheckInclusion = function (applicationMID, personMID) {

            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/CheckApplicationSectionInclusion?sectionName=college&attemptmid={0}', applicationMID);

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {

                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var result = container.Payload.InclusionResult;
                        var sectionsToAdd = Array();
                        var sectionsToRemove = Array();

                        console.log('Inclusion Result for Prev College: ' + result);
                        switch (result) {
                            case "Included":
                                sectionsToAdd.push({ section: 'College', required: false });
                                break;
                            case "Required":
                                sectionsToAdd.push({ section: 'College', required: true });
                                break;
                            case "Exclude":
                                sectionsToRemove.push('College');
                                break;
                        }
                        console.log('Calling Maintain Sections');
                        if (self.sectionVisibleByConfig() === false && (result == "Included" || result == "Required")) {
                            sectionsToAdd = null; // If section is hidden by Configuration, don't add the section
                        }
                        viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
                    }
                },
                error: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {

            var atoList = Array();

            for (var i = 0; i < self.DataList().length; i++) {
                var dataListItem = self.DataList()[i];
                var ato = dataListItem.ExtractATO();
                atoList.push(ko.toJS(ato));
            }

            return atoList;

        };
        /*** SECTION METHODS ***/

        var self = this;
        return self;
    };

    /**************************************/
    // Previous College Data Item
    //  Single College View Model
    /**************************************/
    function CollegeDataItem(options) {
        var defaults = {
            CollegeID: '', //0, // Remove due to validation false positive
            CollegeName: '',
            GradePoint: '',
            GradePointOf: 4,
            StartDate: '',
            EndDate: '',
            Comments: '',
            StatusID: '',
            Status: '',
            PersonAcademicGoalID: 0,
            EducationalGoal: '',
            OtherEducationalGoal: '',
            SectionRequired: false,
            InEditMode: false,
            ID: -1,
            GID: null,
            StudentID: '',
            ProgramName: '',
            ConferralDate: '',
            Credential: '',
            CredentialID: '',
            City: '',
            IsProgramConferralRequired: false
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.CollegeID = ko.validatedObservable(settings.CollegeID);
        this.CollegeName = ko.validatedObservable(settings.CollegeName);
        this.GradePoint = ko.validatedObservable(settings.GradePoint);
        this.GradePointOf = ko.validatedObservable(settings.GradePointOf);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.Comments = ko.validatedObservable(settings.Comments);
        this.StatusID = ko.validatedObservable(settings.StatusID);
        this.Status = ko.validatedObservable(settings.Status);
        this.PersonAcademicGoalID = ko.validatedObservable(settings.PersonAcademicGoalID);
        this.EducationalGoal = ko.validatedObservable(settings.EducationalGoal);
        this.OtherEducationalGoal = ko.validatedObservable(settings.OtherEducationalGoal);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);

        // New fields added only for APAS
        this.StudentID = ko.validatedObservable(settings.StudentID);
        this.ProgramName = ko.validatedObservable(settings.ProgramName);
        this.ConferralDate = ko.validatedObservable(settings.ConferralDate);
        this.Credential = ko.validatedObservable(settings.Credential);
        this.CredentialID = ko.validatedObservable(settings.CredentialID);
        this.City = ko.validatedObservable(settings.City);
        this.IsProgramConferralRequired = ko.observable(settings.IsProgramConferralRequired);

        this.SectionRequired = ko.observable(settings.InEditMode);
        this.InEditMode = ko.observable(settings.InEditMode);

        /*** SUBSCRIBED PROPERTIES ***/
        this.PersonAcademicGoalID.subscribe(function (newValue) {
            var educationalGoal = jQuery('input.combobox[data-val-target="EducationalGoalID"]').val();
            this.EducationalGoal(educationalGoal);
        }, this);

        this.CredentialID.subscribe(function(newValue) {
            newValue ? this.IsProgramConferralRequired(true) : this.IsProgramConferralRequired(false);
        }, this)
        /*** SUBSCRIBED PROPERTIES ***/

        this.ExtractATO = function () {
            return new smapi.admissions.CollegeInformationModel({
                CollegeID: self.CollegeID(),
                CollegeName: self.CollegeName(),
                GradePoint: self.GradePoint(),
                GradePointOf: self.GradePointOf(),
                StartDate: self.StartDate(),
                EndDate: self.EndDate(),
                Comments: self.Comments(),
                StatusID: self.StatusID(),
                PersonAcademicGoalID: self.PersonAcademicGoalID(),
                EducationalGoal: self.EducationalGoal(),
                ID: self.ID(),
                GID: self.GID(),
                StudentID: self.StudentID(),
                ProgramName: self.ProgramName(),
                ConferralDate: self.ConferralDate(),
                CredentialID: self.CredentialID(),
                City: self.City(),
                /*OtherEducationalGoal: self.OtherEducationalGoal()*/
            });
        }

        this.Clone = function () {
            return new sm.portal.vm.CollegeDataItem({
                CollegeID: self.CollegeID(),
                CollegeName: self.CollegeName(),
                GradePoint: self.GradePoint(),
                GradePointOf: self.GradePointOf(),
                StartDate: self.StartDate(),
                EndDate: self.EndDate(),
                Comments: self.Comments(),
                StatusID: self.StatusID(),
                Status: self.Status(),
                PersonAcademicGoalID: self.PersonAcademicGoalID(),
                EducationalGoal: self.EducationalGoal(),
                OtherEducationalGoal: self.OtherEducationalGoal(),
                InEditMode: self.InEditMode(),
                SectionRequired: self.SectionRequired(),
                ID: self.ID(),
                GID: self.GID(),
                StudentID: self.StudentID(),
                ProgramName: self.ProgramName(),
                ConferralDate: self.ConferralDate(),
                CredentialID: self.CredentialID(),
                City: self.City(),
                Credential: self.Credential(),
                IsProgramConferralRequired: self.IsProgramConferralRequired()
            });
        };

        /*** VALIDATION METHODS ***/
        this.CollegeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return sm.portal.utility.isNullOrEmpty(self.CollegeName());
                }
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CollegeName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return sm.portal.utility.isNullOrEmpty(self.CollegeID());
                }
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.GradePoint.extend({
            min: {
                params: -9.9999,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '-9.9999')
            },
            max: {
                params: 9.9999,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '9.9999')
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            maxDecimals: {
                params: 4,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_Decimals), '4')
            }
        });
        this.GradePointOf.extend({
            min: {
                params: -9.9999,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '-9.9999')
            },
            max: {
                params: 9.9999,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '9.9999')
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            maxDecimals: {
                params: 4,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_Decimals), '4')
            }
        });
        this.StartDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return sm.portal.utility.isAPASFeatureEnabled();
                }
            },
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            },
            smDateRange: {
                params: { start: this.StartDate, end: this.EndDate },
                message: "Please use a valid date range, with valid dates"
            }
        });
        this.EndDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return sm.portal.utility.isAPASFeatureEnabled();
                }
            },
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Comments.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonAcademicGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OtherEducationalGoal.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.StudentID.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.ProgramName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.IsProgramConferralRequired();
                }
            },
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ConferralDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.IsProgramConferralRequired();
                }
            },
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        PreviousCollegeViewModel: PreviousCollegeViewModel,
        CollegeDataItem: CollegeDataItem,
    });

})(jQuery);